module.exports = __webpack_public_path__ + "img/content.03b8b3c6.png";